import apiConfig from "constants/apiConfig"
import axiosClient from "utils/axiosClient"

export const fetchCompetitionGroups = async (agencyId: string, payload: any = {}) => {
    const response = await axiosClient.get(apiConfig.FETCH_COMPETITION_GROUPS.url.replace('<agencyId>', agencyId), { params: { ...(payload ? { ...payload } : {}) } });
    return response.data;
}

export const fetchCompetitionGroup = async (agencyId: string, competitionGroupId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_COMPETITION_GROUP.url.replace('<agencyId>', agencyId).replace('<competitionGroupId>', competitionGroupId));
    return response.data;
}

export const fetchCreatorsOverlappingData = async (agencyId: string, competitionGroupId: string, socialAccountId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_COMPETITION_GROUP_CREATORS_OVERLAPPING_DATA.url.replace('<agencyId>', agencyId).replace('<competitionGroupId>', competitionGroupId).replace('<socialAccountId>', socialAccountId));
    return response.data;
}

export const addCompetitionReport = async (agencyId: string, payload: any) => {
    const response = await axiosClient.post(apiConfig.CREATE_COMPETITION_GROUPS.url.replace('<agencyId>', agencyId), payload);
    return response.data;
} 

export const addCompetitor = async (agencyId: string, payload: any) => {
    const response = await axiosClient.post(apiConfig.ADD_COMPETITOR.url.replace('<agencyId>', agencyId), payload);
    return response.data;
} 

export const fetchCompetitors = async (agencyId: string, payload: any = {}) => {
    const response = await axiosClient.get(apiConfig.FETCH_COMPETITORS.url.replace('<agencyId>', agencyId), { params: { ...(payload ? { ...payload } : {}) } });
    return response.data;
}

export const updateCompetitionReport = async (agencyId: string, competitionGroupId: string, payload: any) => {
    const response = await axiosClient.put(apiConfig.UPDATE_COMPETITION_GROUPS.url.replace('<agencyId>', agencyId).replace('<competitionGroupId>', competitionGroupId), payload);
    return response.data;
} 

export const fetchCompetitionReportShareId = async (agencyId: string, competitionGroupId: string) => {
    const response = await axiosClient.post(apiConfig.FETCH_COMPETITION_REPORT_SHARE_ID.url.replace('<agencyId>', agencyId).replace('<competitionGroupId>', competitionGroupId));
    return response.data;
}

export const fetchSharedCompetitionGroup = async (competitionGroupShareId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SHARED_COMPETITION_GROUP.url.replace('<competitionGroupShareId>', competitionGroupShareId));
    return response.data;
}